/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon32Regular = forwardRef('ArrowShapeTriangleAUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.7 25c-2.174 0-3.488-2.403-2.315-4.234l9.3-14.507c1.082-1.688 3.548-1.688 4.63 0l9.3 14.507c1.173 1.83-.142 4.234-2.316 4.234H6.7Zm-.631-3.154A.75.75 0 0 0 6.7 23h18.6a.75.75 0 0 0 .63-1.154L16.632 7.338a.75.75 0 0 0-1.263 0l-9.3 14.508Z" })));
});
